<template>
  <div>
    <v-container grid-list-md style="background-color: transparent">
      <v-layout row wrap>
        <v-flex>
          <v-list three-line>
            <div v-if="surveys.length">
              <survey-item v-for="survey in surveys" :key="survey.id" :survey="survey"></survey-item>
            </div>
          </v-list>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import SurveyItem from "./SurveyItem";
export default {
  components: {
    SurveyItem
  },
  props: {
    surveys: {
      type: Array,
      required: true
    }
  }
};
</script>
